export type WhatsAppContactLike = {
    poc_contact?: string | null;
    office_tel?: string | null;
};

export type WhatsAppResolution = {
    normalizedNumber: string | null;
    source: 'poc_contact' | 'office_tel' | null;
};

export function normalizeWhatsAppNumber(raw?: string | null): string | null {
    const input = String(raw || '').trim();
    if (!input) return null;
    if (/[A-Za-z]/.test(input)) return null;

    let normalized = input.replace(/[\s().-]/g, '');
    if (normalized.startsWith('+')) normalized = normalized.slice(1);
    if (normalized.startsWith('00')) normalized = normalized.slice(2);
    normalized = normalized.replace(/[^0-9]/g, '');

    if (normalized.length < 8) return null;
    return normalized;
}

export function resolveWhatsAppNumber(target?: WhatsAppContactLike | null): WhatsAppResolution {
    const poc = normalizeWhatsAppNumber(target?.poc_contact);
    if (poc) return { normalizedNumber: poc, source: 'poc_contact' };
    const office = normalizeWhatsAppNumber(target?.office_tel);
    if (office) return { normalizedNumber: office, source: 'office_tel' };
    return { normalizedNumber: null, source: null };
}

export function openWhatsAppMessage(message: string, target?: WhatsAppContactLike | null): WhatsAppResolution {
    const resolved = resolveWhatsAppNumber(target);
    const encoded = encodeURIComponent(message);
    const url = resolved.normalizedNumber
        ? `https://wa.me/${resolved.normalizedNumber}?text=${encoded}`
        : `https://wa.me/?text=${encoded}`;
    window.open(url, '_blank', 'noopener,noreferrer');
    return resolved;
}
